import { Media } from "./media";

export interface Program {
    id: number;
    name: string;
    description: string;
    date_start: string;
    date_end: string;
    user_display_name: string;
    user_email: string;
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyProgram: Program = {
    id: 0,
    name: '',
    description: '',
    date_start: '',
    date_end: '',
    user_display_name: '',
    user_email: '',
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}

export interface ProgramMember {
    id: number;
    program_id: number;
    entity_type: 'club' | 'team' | 'user';
    entity_id: number;
    entity_name: string;
    entity_description: string;
    role?: string;
    members_count?: number;
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyProgramMember: ProgramMember = {
    id: 0,
    program_id: 0,
    entity_type: 'user',
    entity_id: 0,
    entity_name: '',
    entity_description: '',
    members_count: 0,
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}

export interface ProgramMemberOption {
    id: number;
    name: string;
    email?: string;
    role?: string;
    club_name?: string;
    members_count?: number;
}

export interface ProgramMemberOptions {
    clubs: ProgramMemberOption[];
    teams: ProgramMemberOption[];
    users: ProgramMemberOption[];
}

export interface ProgramFolder {
    id: number;
    program_id: number;
    parent_folder_id: number | null;
    name: string;
    description: string;
    weight: number;
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyProgramFolder: ProgramFolder = {
    id: 0,
    program_id: 0,
    parent_folder_id: null,
    name: '',
    description: '',
    weight: 0,
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}

export interface ProgramMedia {
    id: number;
    program_id: number;
    folder_id: number | null;
    name: string;
    description: string;
    media: Media[];
    comments_count?: number;
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyProgramMedia: ProgramMedia = {
    id: 0,
    program_id: 0,
    folder_id: null,
    name: '',
    description: '',
    media: [],
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}

export interface ProgramMediaComment {
    id: number;
    program_media_id: number;
    user_display_name: string;
    user_email: string;
    comment: string;
    media: Media[];
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyProgramMediaComment: ProgramMediaComment = {
    id: 0,
    program_media_id: 0,
    user_display_name: '',
    user_email: '',
    comment: '',
    media: [],
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}